<div>
    <!-- <label class="input-text" for="nombre">
{{'categories.selecciona' | translate}}
</label> -->
    <ng-select (change)="change($event)" [items]="list" 
        (scrollToEnd)="scrollTablet()" [searchable]="true" bindLabel="name" bindValue="id"
         class="input-text w-56 max-w-full" style="height:42px;padding-top: 0.65rem;" 
         placeholder="{{'categories.elegir' | translate}}">
    </ng-select>
</div>